import {
  Icon,
  MenuItem,
  PopupMenu,
  useTogglePopupMenu,
} from '@pandiafi/design-system'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Contract, UserMetadata } from '../../../../../common/validations'
import { ContractLabel } from '../ContractLabel/ContractLabel'
import { resolveContractLabel } from '../../utils/resolveContractLabel'
import { makeContractFrontPageURL } from '../../../../router/routePath'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

interface ContractSelectorProps {
  contracts?: Contract[]
  userMetadata?: UserMetadata
}

export const ContractSelector: React.FC<ContractSelectorProps> = ({
  contracts = [],
  userMetadata,
}) => {
  const { isOpen, toggle, close, parentRef } =
    useTogglePopupMenu<HTMLDivElement>()

  const { currentContractId } = useCurrentContract()

  const navigate = useNavigate()

  const handleMenuClick = () => {
    toggle()
  }

  const handleSelectedContract = (contract: Contract) => {
    navigate(makeContractFrontPageURL(contract.uuid))
    close()
  }

  const selectedContract =
    contracts.find((c) => c.uuid === currentContractId) ?? contracts[0]

  const selectedContractLabel =
    selectedContract && resolveContractLabel(selectedContract)

  return (
    <div className="flex justify-center" ref={parentRef}>
      {contracts.length === 1 ? (
        <ContractLabel
          label={selectedContractLabel}
          userMetadata={userMetadata}
        />
      ) : (
        <>
          <button
            onClick={handleMenuClick}
            className="w-full space-x-4 flex items-center justify-center rounded-md p-2 text-brand-7 hover:bg-brand-1"
          >
            <ContractLabel
              label={selectedContractLabel}
              userMetadata={userMetadata}
            />
            <Icon icon="angle-down" className="ml-1" />
          </button>

          {isOpen && (
            <PopupMenu
              show={isOpen}
              location="center"
              className="rounded-md bg-white/95 p-2 text-brand-6"
            >
              {contracts.map((contract) => (
                <MenuItem
                  key={contract.uuid}
                  onClick={() => handleSelectedContract(contract)}
                >
                  {resolveContractLabel(contract)}
                </MenuItem>
              ))}
            </PopupMenu>
          )}
        </>
      )}
    </div>
  )
}
